import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import authBgImg from "../../images/bg-img.png";
import { InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useApp from "../../store/contexts/AppContext";
import Copyright from "../../components/Copyright/Copyright";
import { useLocation, useHistory } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { REACT_APP_AFTER_LOGIN_REDIRECT_URL } from "../../config";

export default function ResetPassword() {
  const {
    appState: { appName, accessToken, dataLoading },
    resetPasswordApiCall,
  } = useApp();

  const location = useLocation();
  const history = useHistory();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const hour = new Date().getHours();
  const isDay = hour >= 6 && hour < 18;
  const authTheme = createTheme({
    palette: {
      mode: isDay ? "light" : "dark",
      primary: { main: "#d44401" },
      background: {
        default: isDay ? "#f8f9fa" : "#0a0a0a",
        paper: isDay ? "#ffffff" : "#0a0a0a",
      },
    },
  });

  const searchParams = new URLSearchParams(location.search);
  //get the value of token on the url query
  const userToken = searchParams.get("token");

  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const handleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const dataToPass = {
      password: form.get("newPassword"),
      confirm_password: form.get("confirmPassword"),
    };
    resetPasswordApiCall(dataToPass, userToken);
  };

  useEffect(() => {
    if (accessToken) {
      history.push(REACT_APP_AFTER_LOGIN_REDIRECT_URL);
    }
  }, [accessToken, history]);

  // Prevent rendering if already authenticated
  if (accessToken) {
    return null;
  }

  return (
    <ThemeProvider theme={authTheme}>
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: `url(${authBgImg})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: isDay ? "#f8f9fa" : "#0a0a0a",
          backgroundSize: "cover",
          // backgroundPosition: "center",
        }}
      />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset password on {appName}
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 1 }}
          >
            <TextField
              margin="dense"
              required
              fullWidth
              label="New Password"
              id="newPassword"
              name="newPassword"
              autoComplete="newPassword"
              autoFocus
              type={showNewPassword ? "text" : "password"}
              value={newPassword}
              onChange={handleNewPasswordChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleNewPasswordVisibility}>
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              margin="dense"
              required
              fullWidth
              label="Confirm Password"
              id="confirmPassword"
              name="confirmPassword"
              autoComplete="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleConfirmPasswordVisibility}>
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Submit{" "}
              {dataLoading && (
                <CircularProgress sx={{ color: "white", ml: 2 }} size={24} />
              )}
            </Button>

            <Copyright sx={{ mt: 5 }} />
          </Box>
        </Box>
      </Grid>
    </Grid>
    </ThemeProvider>
  );
}
